//TODO: support Begins with, contains, exact?   option for case sensitive?

//TODO:  Optimize.   Would it be better to loop through search keys at each object level and look for searchkey in obj?
//TODO:  Better search function for deep objects.   Specify full path to deep key vs just name "Phones.Phone[].Phone_Num"  would that be faster?
//TODO:  Option to bring back array of what item matched in the search
//TODO:  Implement special search for amounts (strip out , and $).   Transform "$1,345.67" to "1345.67".  Need a way to identify amount columns.
//TODO:  Implement special search for dates.   Transform entries like 1/12/2017 to 2017-01-12,  1/17 to 2017-01, etc.
//TODO:  Implement ability to search a single element (present dropdown of search keys in control -- only valid when a specific list of keys in given)

import { Injectable, Pipe, PipeTransform } from '@angular/core';

export class FilterType {
    keys: {}; //list of available search keys.  (keyname: User description)   { Entity_Index_Name: 'Name', Entity_Name: 'Name', Phone_Num: 'Phone'};
    filterKey: string = '[ALL]'; //current key to search or [ALLKEYS]  or [GLOBAL] -- search all fields (use carefully)
    filterText: string = ''; //filter text
    deep: boolean = false; //perform a deep search (beyond elements at root of object);   **LEGACY VALUE ** -- set maxDepth instead
    maxDepth: number = 1; //max search depth.   0 indicates unlimited depth
}

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epFilter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
    maxDepth: number = 1;
    first: boolean = true;

    termRegExp: RegExp;
    termPhoneRegExp: RegExp;

    transform(value: any, filter: FilterType) {
        //if no FilterText then quickly return true -- Nothing to Filter
        if (!value) {
            return;
        } //****Needed ????   Added when working on contract search result

        if (filter.deep && this.first) {
            console.warn("Legacy parameter 'deep' used in filter pipe.   Use maxDepth instead.");
            this.maxDepth = 0; //unlimited
            this.first = false;
        }

        if (filter.maxDepth) {
            this.maxDepth = filter.maxDepth;
        }

        if (!filter.filterText || filter.filterText == '') {
            return value.filter((item: any) => true);
        }

        if (!filter.filterKey) {
            filter.filterKey = '[ALL]';
        }

        let cleanFilter = filter.filterText.replace(/[\(\)\*\[\]\\]/g, ''); //remove ()*[]\ from filter.  These are not valid in a regexp search
        let cleanPhoneFilter = cleanFilter.replace(/[.-]/g, ''); //remove . and - from typed in filter on phone numbers

        this.termRegExp = new RegExp(cleanFilter, 'i');
        this.termPhoneRegExp = new RegExp(cleanPhoneFilter, 'i');

        //if only one searchkey and not a deep search then do simple (fast search)
        if (!(filter.filterKey.toUpperCase() == '[ALL]') && filter.maxDepth == 1) {
            return value.filter((item: any) => item[filter.filterKey].search(this.termRegExp) >= 0);
        }
        //filter based on ALL defined keys
        if (filter.filterKey.toUpperCase() == '[ALL]') {
            return value.filter((item: any) => this.search(item, filter.keys, 1));
        }
        //filter based on any filed in json data -- GLOBAL search
        if (filter.filterKey.toUpperCase() == '[GLOBAL]') {
            //console.log("[GLOBAL] Filter");
            return value.filter((item: any) => this.search(item, null, 1));
        } else {
            //filter based in one key
            let singleKey = {};
            singleKey[filter.filterKey] = 'temp';
            return value.filter((item: any) => this.search(item, singleKey, 1));
        }
    }

    search(obj: any, filterKeys: any, currentDepth: number): boolean {
        //returns true if search term found in json object
        // if searchkeys are provided it will only look for a match in value

        let i = 0;
        let k: any;

        let searchAllKeys = !filterKeys || filterKeys.length == 0;

        //loop through root object keys
        for (k in obj) {
            //continue if no value for key
            //console.log(k)
            if (!obj.hasOwnProperty(k)) {
                continue;
            }
            if (typeof obj[k] === 'boolean') {
                continue;
            }
            //if value at key is a simple value test the value of the object
            if (!(obj[k] instanceof Array || typeof obj[k] == 'object' || obj[k] instanceof Object)) {
                if (searchAllKeys || k in filterKeys) {
                    /* console.log (k + ' is not array or object') */
                    if (k == 'Phone_Num') {
                        /* Special search for phone numbers */
                        if (obj[k].search(this.termPhoneRegExp) >= 0) {
                            return true;
                        }
                    } else if (obj[k].search(this.termRegExp) >= 0) {
                        return true;
                    }
                }
            } else if (this.maxDepth == 0 || currentDepth < this.maxDepth) {
                //if value at key is an object and deep search is on then recurse and search the object
                //console.log('deep search on ' + k)
                if (this.search(obj[k], filterKeys, currentDepth + 1)) {
                    return true;
                }
            }
        }
        return false;
    }
}
